import React from 'react'

import CardComImagem from '../CardComImagem'
import CardSimplesBotao from '../CardSimplesBotao'
import CardImagemVazada from '../CardImagemVazada'
import Card from '../../Card'
import CardSimples from '../CardSimples'

const CardTemplateSelector = (props) => {
  const { card } = props

  if (card.templateCard === 'Simples') return <CardSimples {...props} />

  if (card.templateCard === 'ComImagem') return <CardComImagem {...props} />

  if (card.templateCard === 'Card Simples Botao')
    return <CardSimplesBotao {...props} />

  if (card.templateCard === 'Card Imagem Vazada')
    return <CardImagemVazada {...props} />

  return <Card {...props} />
}

export default CardTemplateSelector
